import { booleanColumn } from '@/shared/grids/columns/booleanColumn';
import { dateColumn } from '@/shared/grids/columns/dateColumn';
import { hiddenColumn } from '@/shared/grids/columns/hiddenColumn';
import { idColumn } from '@/shared/grids/columns/idColumn';
import { notesExcerptColumn } from '@/shared/grids/columns/notesExcerptColumn';
import { notesIconColumn } from '@/shared/grids/columns/notesIconColumn';
import {
  completionDueTaskCountColumn,
  deadlineDateDueTaskCountColumn,
  startDueTaskCountColumn,
  uncompletedTaskCountColumn,
} from '@/shared/grids/columns/taskCountColumn';
import { textColumn } from '@/shared/grids/columns/textColumn';
import { GridSettings } from '@/shared/types/grid';

import { IndividualView } from '@prisma/client';

export const individualGrid: GridSettings<IndividualView> = {
  defaultSort: {
    name: 'asc',
  },
  columns: [
    // Hidden columns
    idColumn(),
    hiddenColumn({
      field: 'serviceIds',
    }),
    hiddenColumn({
      field: 'dueTimeFrames',
    }),
    // Visible columns
    notesIconColumn({
      field: 'hasNotes',
    }),
    textColumn({
      header: 'Reference',
      field: 'internalReference',
      visible: false,
    }),
    textColumn({
      header: 'First Name',
      field: 'givenName',
    }),
    textColumn({
      header: 'Last Name',
      field: 'surname',
    }),
    dateColumn({
      header: 'DOB',
      field: 'birthDate',
      visible: false,
    }),
    textColumn({
      header: 'UTR Number',
      field: 'utr',
      visible: false,
    }),
    textColumn({
      header: 'NI Number',
      field: 'nationalInsuranceNumber',
      visible: false,
    }),
    textColumn({
      header: 'Passport Number',
      field: 'passportNumber',
      visible: false,
    }),
    textColumn({
      header: 'Phone',
      field: 'contactTelephoneNumber',
    }),
    textColumn({
      header: 'Email',
      field: 'emailAddress',
    }),
    dateColumn({
      header: 'Registered as Tax Agent',
      field: 'registeredAsTaxAgentDate',
      visible: false,
    }),
    dateColumn({
      header: 'Trading Start Date',
      field: 'tradingStartDate',
      visible: false,
    }),
    booleanColumn({
      header: 'Tax Return Required',
      field: 'taxReturnRequired',
    }),
    dateColumn({
      header: 'Tax Return Last Made Up To',
      field: 'taxReturnLastMadeUpToDate',
      visible: false,
    }),
    dateColumn({
      header: 'Tax Return Period End',
      field: 'taxReturnPeriodEndDate',
      visible: false,
    }),
    dateColumn({
      header: 'Tax Return Due',
      field: 'taxReturnDueDate',
      due: true,
    }),
    uncompletedTaskCountColumn({
      linkIdField: 'clientId',
    }),
    startDueTaskCountColumn({
      linkIdField: 'clientId',
      visible: false,
    }),
    completionDueTaskCountColumn({
      linkIdField: 'clientId',
      visible: false,
    }),
    deadlineDateDueTaskCountColumn({
      linkIdField: 'clientId',
      visible: false,
    }),
    dateColumn({
      header: 'Added',
      field: 'createdTime',
      visible: false,
    }),
    dateColumn({
      header: 'Engagement Signed',
      field: 'engagementSignedDate',
      visible: false,
      emptyText: 'Not signed',
      emptyClass: 'text-danger',
    }),
    dateColumn({
      header: 'AML Last Checked',
      field: 'amlLastCheckedDate',
      visible: false,
      emptyText: 'Never checked',
      emptyClass: 'text-danger',
    }),
    dateColumn({
      header: 'AML Check Due',
      field: 'amlCheckDueDate',
      visible: false,
      due: true,
      emptyText: 'Never checked',
      emptyClass: 'text-danger',
    }),
    textColumn({
      header: 'Account Manager',
      field: 'accountManagerId',
      extra: {
        displayField: 'accountManagerName',
        sortField: 'accountManagerName',
        filter: {
          lookup: 'MemberView',
        },
      },
    }),
    notesExcerptColumn({
      field: 'notesExcerpt',
    }),
    dateColumn({
      header: 'Archived',
      field: 'archivedTime',
      visible: false,
    }),
  ],
};
